import { Badge } from '@/components/design-system/badge';

import { useNavigationContext } from '../context/NavigationContext';

interface NavBadgeProps {
  badge: boolean | string | undefined;
}

export const NavBadge = ({ badge }: NavBadgeProps) => {
  const { isNavCollapsed } = useNavigationContext();

  if (badge === undefined || badge === false) {
    return null;
  }

  if (isNavCollapsed) {
    return <Badge variant="dot" className="absolute top-2 right-2" />;
  }

  return (
    <Badge variant="new" className="h-[17px] px-[5px] py-0 text-xs">
      {typeof badge === 'string' ? badge : 'NEW'}
    </Badge>
  );
};
